module.exports = __webpack_public_path__ + "img/align-right.b5ac91b1.svg";